import {
    Component,
    Input,
    Output,
    SimpleChanges,
    EventEmitter,
    ViewEncapsulation
} from '@angular/core';
import moment from 'moment';
import { SelectItem, SortEvent } from 'primeng/api';
import { Table } from "primeng/table";
import { PrimeNGConfig } from 'primeng/api';
import { TranslocoService } from '@ngneat/transloco';

@Component({
    selector: 'fuse-table',
    templateUrl: './table.component.html',
    exportAs: 'fuseTable',
    styleUrls: ['./table.component.scss'],
})
export class FuseTableComponent {
    @Output() actionEvent = new EventEmitter(); //for action buttons
    @Output() selectEvent = new EventEmitter(); //For checkbox field
    @Output() onLoad = new EventEmitter(); //called on table load
    @Input() isToggle: boolean = false; //table column toggle; flag
    @Input() isFilterable: boolean = true; //to allow filters and sort
    @Input() isSelectable: boolean = false; //for checkbox; flag
    @Input() isPaginator: boolean = true; //for checkbox; flag
    @Input() totalRecords: number = 0; //total records in table 10 rows?
    @Input() rows: number = 20;
    @Input() columns: any[] //List of all columns json
    @Input() rowData: any; //Table data
    @Input() isLoading: any; //Loading flag
    @Input() selectedRows: any[] = [];
    @Input() stateKey: string;
    @Input() leftClick: false;
    @Output() leftClickEvent = new EventEmitter();
    @Input() hideToggleSearch: boolean = false; //table column toggle; flag
    @Input() url: string = '';


    @Input() timesheetTable: boolean = false; //Timesheet column toggle; flag
    @Input() DropTownValue: []; //Timesheet column toggle; flag
    @Output() changeDectection = new EventEmitter();

    actionButtons: any[];
    _selectedColumns: any[];

    presistState: boolean = false;
    globalSearchString: string = '';
    columnsState: any[];
    updatedColumns: any[];

    constructor(private config: PrimeNGConfig, private translocoService: TranslocoService) {
    }

    translate(text: any) {
        return this.translocoService.translate(text, {}, this.translocoService.getActiveLang());
    }

    ngOnChanges(simple: SimpleChanges) {
        this.updatedColumns = [...this.columns.filter(item => item.type !== 'actions')]
        this.columnsState = JSON.parse(localStorage.getItem(this.stateKey + ' columns'));
        if (simple['rowData'] && !this.presistState && (!this.columnsState || this.columnsState.length === 0)) {
            if (this.isToggle && this.columns.length > 5) {
                this.selectedColumns = this.columns.filter((_, index) => index < 6);
                let isAction = this.columns[this.columns.length - 1].field //Is last field action?
                if (isAction === 'actions') {
                    this.selectedColumns = [...this.selectedColumns, this.columns[this.columns.length - 1]];
                    let actionsBtns = this.columns.filter(item => item.type == 'actions')[0]?.values;
                    if (actionsBtns) {
                        this.actionButtons = [...this.columns.filter(item => item.type == 'actions')[0]?.values];
                    }
                }
            }
            else {
                this.selectedColumns = this.columns;
                let actionsBtns = this.columns.filter(item => item.type == 'actions')[0]?.values;
                if (actionsBtns) {
                    this.actionButtons = [...this.columns.filter(item => item.type == 'actions')[0]?.values];
                }
            }
        }
        else {
            this.selectedColumns = this.columns.filter(col => this.columnsState.some(column => column.field === col.field));
            let actionsBtns = this.columns.filter(item => item.type == 'actions')[0]?.values;
            if (actionsBtns) {
                this.actionButtons = [...this.columns.filter(item => item.type == 'actions')[0]?.values];
            }
        }
    }

    @Input() get selectedColumns(): any[] {
        return this._selectedColumns;
    }

    set selectedColumns(val: any[]) {
        if (val.length > 0) {
            localStorage.setItem(this.stateKey + ' columns', JSON.stringify(val))
        }
        this._selectedColumns = this.columns.filter(col => val.includes(col));
        this.presistState = true;
    }

    onAction(event, itemLabel, entity, rowIndex) {
        if (event.target && itemLabel) {
            const payload = {
                type: itemLabel,
                entity,
                rowIndex
            }
            this.actionEvent.emit(payload);
        }
    }
    viewRow(event: any, type: string) {
        const payload = {
            type: 'View',
            entity: event.data,
            rowIndex: 'i'
        }
        this.actionEvent.emit(payload);
        // $event, 'View', rowData, i
        console.log("event", event, type)
    }

    lazyLoad(event) {
        const filterObj = [];
        const filters = event.filters;
        const sortField = event.sortField === 'actions' ? 'createdAt' : event.sortField;
        const sortOrder = event.sortField === 'actions' ? 1 : event.sortOrder;

        Object.keys(filters).forEach((key) => {
            if (filters[key][0] && filters[key][0].value) {
                filterObj.push({ [key]: { "$regex": filters[key][0].value, "$options": "i" } });
            }
            if (filters[key] && filters[key].value) {
                filterObj.push({ [key]: { "$regex": filters[key].value, "$options": "i" } });
                this.globalSearchString = filters[key].value;
            }
        });

        this.onLoad.emit({
            allFilter: filterObj,
            first: event.first,
            rows: event.rows,
            sortField: sortField ? sortField : "lwId",
            sortOrder: sortOrder
        });
    }
    /**
     * Function to post checkbox selection to parent
     */
    postSelection() {
        this.selectEvent.emit(this.selectedRows)
    }

    /**
     * Function to evaluate text or mult-select fields
     */
    getRowData(rowData, col) {
        if (col.field === 'taskCategory') {
            return rowData[col.field] || 'general';
        }
        if (col.type === 'taskAssignee') {
            if (rowData['User']) {
                return rowData['User']['lastName']
            }
            else if (rowData['Teams']) {
                return rowData['Teams']['name']
            }
            else {
                return '';
            }
        }
        if (col.field.includes('.')) {
            let props = col.field.split('.');
            if (rowData[props[0]]) {
                let data = rowData[props[0]];
                for (let i = 1; i < props.length; i++) {
                    data = data[props[i]] || "";
                }
                return data;
            } else {
                return '';
            }
        }
        else {
            return rowData[col.field] || '';
        }
    }

    getColor(rowData, col) {
        if (col.field.includes('.')) {
            let props = col.field.split('.');
            if (rowData[props[0]]) {
                let data = rowData[props[0]][props[1]];
                let index = col.values.indexOf(data);
                return col.colors[index];
            }
        } else {
            let data = rowData[col.field];
            let index = col.values.indexOf(data);
            return col.colors[index];
        }
    }


    clear(table: Table) {
        this.globalSearchString = ''
        table.clear();
        table.clearState();
    }

    openInTab(data, type) {
        this.leftClickEvent.emit({ type: type, view: data })
    }

    MenuOpen(event, menuTrigger) {
        if (this.leftClick) {
            event.preventDefault();
            menuTrigger.openMenu()
        }
    }
    calculateTotalWorkingHour() {
        console.log(this.rowData)
        this.rowData?.forEach(element => {
            this.entityCalculateTotalWorkingHour(element)
        });
        this.changeDectection.emit(this.rowData)
    }

    entityCalculateTotalWorkingHour(entry: any) {

        let eTime = moment(entry.endTime);
        eTime.set({ second: 0, millisecond: 0 });
        let subtracted = moment(eTime.subtract(entry.break, 'minutes'));
        let sTime = moment(entry.startTime);
        sTime.set({ second: 0, millisecond: 0 });
        let diff = subtracted.diff(sTime);
        let f = moment.utc(diff).format('HH:mm');
        if (f == "Invalid date") {
            f = ''
        } else { entry.totalWorkingHours = f; }

    }
    setvalue(value, col) {
        console.log(value)
        this.rowData[col] = value
        this.changeDectection.emit(this.rowData)
    }

    getSelectColumnsLabel() {
        let selectedCount = this.selectedColumns.length;
        if (selectedCount === 0) {
            return 'Choose Columns';
        }
        else {
            const actionExists = this.selectedColumns.some(obj => obj.field === 'actions')
            if (actionExists) {
                selectedCount -= 1;
            }
            return `${selectedCount}`;
        }
    }

    private cache = new Map<any, SelectItem[]>();

    getAsSelect(col: any): SelectItem[] {
        if (this.cache.has(col)) {
            return this.cache.get(col);
        }

        const transformed = col.values.map((element) => ({ label: element, value: element } as SelectItem));
        this.cache.set(col, transformed);
        return transformed;
    }

    getCountryDateFormat(data: any, format: string = 'branch.country'): string {
        const [firstProp, secondProp] = format.split(".");
        const country = data?.[firstProp]?.[secondProp] || 'Germany';
        // Common date formats by country
        const countryFormats = {
            'United States': 'MM/dd/yyyy',
            'United Kingdom': 'dd/MM/yyyy',
            'Germany': 'dd.MM.yyyy',
            'France': 'dd/MM/yyyy',
            'Japan': 'yyyy/MM/dd',
            'China': 'yyyy-MM-dd',
            'Philippines': 'MM/dd/yyyy',
            'United Arab Emirates': 'dd/MM/yyyy',
            'Dubai': 'dd/MM/yyyy',
            'Spain': 'dd/MM/yyyy',
            'Hungary': 'yyyy.MM.dd',
            'Czech Republic': 'dd.MM.yyyy',
            'Italy': 'dd/MM/yyyy',
            'Netherlands': 'dd-MM-yyyy',
            'Poland': 'dd.MM.yyyy',
            'Portugal': 'dd-MM-yyyy',
            'Sweden': 'yyyy-MM-dd',
            'Switzerland': 'dd.MM.yyyy',
            'Austria': 'dd.MM.yyyy',
            'Belgium': 'dd/MM/yyyy',
            // Add more country formats as needed
        };
        return countryFormats[country] || 'dd.MM.yyyy';
    }
}
